import { connect } from 'react-redux';
import { MortgageBanner } from './mortgage';
import { ITrackingReducerState } from '../../../../store/tracking';
import { IState } from '../../../../store';

export interface IMortgageBannerStateProps {
  tracking: ITrackingReducerState;
}

export const mapStateToProps = (state: IState): IMortgageBannerStateProps => {
  return {
    tracking: state.tracking,
  };
};

export const MortgageBannerContainer = connect<IMortgageBannerStateProps>(mapStateToProps)(MortgageBanner);
